import React from 'react';
import { Link } from 'react-router-dom';

import './terms-conditions.scss';

export default props => {
  if (!props.showNotice || props.userRole !== 'publisher') return null;

  return (
    <div className="terms-conditions-banner">
      We have updated our terms and conditions, please&nbsp;
      <Link to="/v2/publisher/terms-conditions">click here</Link>
      &nbsp;to review them
      <span className="narrativ-icon cancel" onClick={props.clickHandler}></span>
    </div>
  );
};
